module.exports = __webpack_public_path__ + "img/udon-noodles-1.7610f2d5.jpg";